import { Component, HostListener, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-line',
  templateUrl: './line.component.html',
  styleUrls: ['./line.component.css']
})
export class LineComponent implements OnInit, OnChanges {
  @Input() lineChartData: any;
  @HostListener('window:resize', ['$event'])
  onResize() {
    setTimeout(() => {
      this._plotLine();
      // this.chartOption?.resize();
    }, 1);
  }
  chartOption: any;
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.lineChartData) {
      this._plotLine();
    }
  }

  private _plotLine() {
    this.chartOption = {
      grid: {
        top: '5%',
        left: '16%',
        right: '5%'
      },
      xAxis: {
        type: this.lineChartData?.xAxisType ? this.lineChartData?.xAxisType : 'category',
        data: this.lineChartData?.xAxisData,
        name: this.lineChartData?.xAxisLabel ? this.lineChartData?.xAxisLabel : '',
        nameLocation: this.lineChartData?.xNameLocation ? this.lineChartData?.xNameLocation : 'middle',
        nameTextStyle: {
          fontFamily: 'Inter',
          fontSize: 12,
          fontWeight: 400,
          color: '#9291A5'
        },
        boundaryGap: false,
        axisTick: {
          show: this.lineChartData?.xAxisTick ? this.lineChartData?.xAxisTick : false
        },
        nameGap: 40,
      },
      yAxis: {
        type: this.lineChartData?.yAxisType ? this.lineChartData?.yAxisType : 'value',
        name: this.lineChartData?.yAxisLabel ? this.lineChartData?.yAxisLabel : '',
        nameLocation: this.lineChartData?.yNameLocation ? this.lineChartData?.yNameLocation : 'middle',
        nameTextStyle: {
          fontFamily: 'Inter',
          fontSize: 12,
          fontWeight: 400,
          color: '#9291A5'
        },
        axisTick: {
          show: this.lineChartData?.yAxisTick ? this.lineChartData?.yAxisTick : false
        },
        splitLine: {
          lineStyle: {
            type: 'dashed'
          }
        },
        axisLabel: {
          width: 39,
          overflow: 'break'
        },
        nameGap: 45
      },
      tooltip: {
        trigger: this.lineChartData?.tooltipTrigger ? this.lineChartData?.tooltipTrigger : 'axis'
      },
      color: this.lineChartData?.color?.length ? this.lineChartData?.color : ['#0B82AD'],
      series: [
        {
          data: this.lineChartData?.yAxisData,
          type: 'line',
          symbol: this.lineChartData?.symbol ? this.lineChartData?.symbol : 'none'
        }
      ]
    };
  }

}
